
import Vue from 'vue';
import { mapGetters } from 'vuex';
import CreateBookingPageActionForm from '../../components/booking-page-actions/CreateBookingPageActionForm.vue';
import { ACTIONS } from '../../constants/actions';
import { GETTERS } from '../../constants/getters';
import { APP_VUEX_MODULES } from '../../constants/vuex-modules';
import BackButton from '../../components/common/BackButton.vue';

export default Vue.extend({
  components: { CreateBookingPageActionForm, BackButton },
  name: 'CreateBookingPageAction',
  created(): void {
    if (this.specialFields.length < 1) {
      this.getFormSpecialFields();
    }
  },
  computed: {
    ...mapGetters(APP_VUEX_MODULES.bookings, {
      bookingPage: GETTERS.bookings.getSelectedBookingPage
    }),
    ...mapGetters(APP_VUEX_MODULES.actions, {
      isSubmitting: GETTERS.actions.isCreatingAction
    }),
    ...mapGetters(APP_VUEX_MODULES.forms, {
      specialFields: GETTERS.forms.formSpecialFields
    })
  },
  methods: {
    onFormSubmit(data: any): void {
      const bookingPageId = this.bookingPage.id;
      const { dispatch } = this.$store;
      dispatch(ACTIONS.actions.createAction, { bookingPageId, data });
    },
    getFormSpecialFields(): void {
      const bookingPageId = parseInt(this.$route.params['bookingPageId'], 10);
      const { dispatch } = this.$store;
      dispatch(ACTIONS.forms.getFormSpecialFields, { bookingPageId });
    }
  }
});
